import * as React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import {
  FaIcon,
  faTruckSolid,
  faArrowLeft,
  faArrowRight,
  faChevronDown,
} from '@/lib/fa'
import { TaskStatusWrapper } from '@/modules/shared/components'
import ViewMode from './ViewMode'

import { VehiclePicker } from './VehiclePicker'
import { VEHICLE_ROUTES } from '../../routes-typed'

interface VehicleViewControlBarLayoutProps {
  blockedView?: boolean
  registrationNumber: string
  onPrev: () => void
  onNext: () => void
  children?: React.ReactNode
}

const VehicleViewControlBarLayout: React.FC<VehicleViewControlBarLayoutProps> =
  ({
    blockedView = false,
    registrationNumber,
    onPrev,
    onNext,
    children,
  }) => {
    const [isPickerOpen, setIsPickerOpen] = React.useState(false)
    const { companyId } = useParams<{ companyId: string }>()
    const navigate = useNavigate()

    const handleVehicleSelect = (vehicleId: string) => {
      setIsPickerOpen(false)
      navigate(
        VEHICLE_ROUTES.basicData.buildPath({
          companyId: companyId,
          vehicleId: Number(vehicleId),
        }),
      )
    }

    return (
      <TaskStatusWrapper>
        <div className="tw-relative tw-flex tw-w-full tw-flex-row tw-justify-start tw-gap-2 tw-border-b ">
          <ViewMode  />

          <div className="tw-flex tw-flex-wrap-reverse tw-justify-between tw-flex-1 tw-gap-2 sm:tw-items-center tw-py-2 sm:tw-justify-start sm:tw-gap-6">
            {/* <CompanyNameBadge /> */}
            <div className="tw-flex tw-items-center tw-gap-5">
              <div className="tw-flex tw-items-center tw-gap-2">
                <div
                  className="tw-grid tw-cursor-pointer tw-place-items-center tw-rounded-full tw-p-2 tw-shadow-md"
                  onClick={onPrev}
                >
                  <FaIcon icon={faArrowLeft} className="tw-h-4 tw-w-4" />
                </div>

                <div
                  className="tw-grid tw-cursor-pointer tw-place-items-center tw-rounded-full tw-p-2 tw-shadow-md"
                  onClick={onNext}
                >
                  <FaIcon icon={faArrowRight} className="tw-h-4 tw-w-4" />
                </div>
              </div>

              <div className="tw-relative tw-flex tw-items-center tw-gap-1">
                <FaIcon icon={faTruckSolid} className="tw-w-4" />
                <div
                  className="tw-flex tw-min-w-[200px] tw-cursor-pointer tw-items-center tw-gap-2"
                  onClick={(e) => {
                    e.preventDefault()
                    e.stopPropagation()
                    setIsPickerOpen((prev) => !prev)
                  }}
                >
                  <p className="tw-text-xl tw-font-semibold tw-text-content-base">
                    {registrationNumber}
                  </p>
                  <FaIcon icon={faChevronDown} className="tw-cursor-pointer" />
                </div>
                {isPickerOpen && companyId && (
                  <VehiclePicker
                    companyId={companyId}
                    onSubmit={handleVehicleSelect}
                    close={() => setIsPickerOpen(false)}
                  />
                )}
              </div>

              <div>{children}</div>
            </div>
          </div>
        </div>
      </TaskStatusWrapper>
    )
  }

export default VehicleViewControlBarLayout
